<template>
  <div class="game-distribution-mobile">
    <!-- 图表容器 -->
    <div class="chart-card">
      <div class="card-header">
        <span class="card-title">赛事分布</span>
      </div>
      <div class="chart-container">
        <!-- 赛事类型分布 -->
        <div class="chart-section">
          <div class="section-header">
            <h3 class="section-title">赛事类型分布</h3>
            <div class="section-actions">
              <el-button type="text" icon="el-icon-download" @click="handleExportType" />
              <el-button type="text" icon="el-icon-full-screen" @click="handleFullscreenType" />
            </div>
          </div>
          <div ref="typeChart" class="sub-chart"></div>
        </div>
        
        <!-- 赛事级别分布 -->
        <div class="chart-section">
          <div class="section-header">
            <h3 class="section-title">赛事级别分布</h3>
            <div class="section-actions">
              <el-button type="text" icon="el-icon-download" @click="handleExportLevel" />
              <el-button type="text" icon="el-icon-full-screen" @click="handleFullscreenLevel" />
            </div>
          </div>
          <div ref="levelChart" class="sub-chart"></div>
        </div>
      </div>
    </div>

    <!-- 赛事类型分布全屏弹窗 -->
    <el-dialog
      :visible.sync="typeDialogVisible"
      :append-to-body="true"
      :modal-append-to-body="false"
      :close-on-click-modal="false"
      width="95%"
      :destroy-on-close="false"
      :show-close="false"
      class="chart-dialog"
      @closed="handleTypeDialogClosed"
      @open="handleTypeDialogOpen"
    >
      <div slot="title" class="dialog-header">
        <span>赛事类型分布</span>
        <div class="dialog-actions">
          <el-button type="text" icon="el-icon-download" @click="handleExportTypeFullscreen" />
          <el-button type="text" icon="el-icon-close" @click="closeTypeDialog" />
        </div>
      </div>
      <div class="fullscreen-chart" ref="typeFullscreenChart"></div>
    </el-dialog>

    <!-- 赛事级别分布全屏弹窗 -->
    <el-dialog
      :visible.sync="levelDialogVisible"
      :append-to-body="true"
      :modal-append-to-body="false"
      :close-on-click-modal="false"
      width="95%"
      :destroy-on-close="false"
      :show-close="false"
      class="chart-dialog"
      @closed="handleLevelDialogClosed"
      @open="handleLevelDialogOpen"
    >
      <div slot="title" class="dialog-header">
        <span>赛事级别分布</span>
        <div class="dialog-actions">
          <el-button type="text" icon="el-icon-download" @click="handleExportLevelFullscreen" />
          <el-button type="text" icon="el-icon-close" @click="closeLevelDialog" />
        </div>
      </div>
      <div class="fullscreen-chart" ref="levelFullscreenChart"></div>
    </el-dialog>
  </div>
</template>

<script>
import * as echarts from 'echarts'
import request from '@/utils/request'
import _ from 'lodash'

export default {
  name: 'GameDistributionChartMobile',
  data() {
    return {
      typeChart: null,
      levelChart: null,
      chartData: {
        types: [],
        levels: []
      },
      typeFullscreenChart: null,
      levelFullscreenChart: null,
      typeDialogVisible: false,
      levelDialogVisible: false,
      resizeHandler: null,
      isInitializing: false,
      loading: false
    }
  },
  mounted() {
    this.initCharts()
    this.fetchData()
    window.addEventListener('resize', this.resizeCharts)
  },
  beforeDestroy() {
    if (this.typeChart) {
      this.typeChart.dispose()
    }
    if (this.levelChart) {
      this.levelChart.dispose()
    }
    if (this.typeFullscreenChart) {
      this.typeFullscreenChart.dispose()
    }
    if (this.levelFullscreenChart) {
      this.levelFullscreenChart.dispose()
    }
    window.removeEventListener('resize', this.resizeCharts)
  },
  watch: {
    typeDialogVisible(val) {
      if (!val && this.typeFullscreenChart) {
        this.typeFullscreenChart.dispose()
        this.typeFullscreenChart = null
      }
    },
    levelDialogVisible(val) {
      if (!val && this.levelFullscreenChart) {
        this.levelFullscreenChart.dispose()
        this.levelFullscreenChart = null
      }
    }
  },
  methods: {
    dataURLToBlob(dataURL) {
      const arr = dataURL.split(',')
      const mime = arr[0].match(/:(.*?);/)[1]
      const bstr = atob(arr[1])
      let n = bstr.length
      const u8arr = new Uint8Array(n)
      while (n--) u8arr[n] = bstr.charCodeAt(n)
      return new Blob([u8arr], { type: mime })
    },
    downloadBlob(blob, filename) {
      const url = URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.download = filename
      link.href = url
      document.body.appendChild(link)
      link.click()
      URL.revokeObjectURL(url)
      document.body.removeChild(link)
    },
    initCharts() {
      this.typeChart = echarts.init(this.$refs.typeChart)
      this.levelChart = echarts.init(this.$refs.levelChart)
    },
    resizeCharts() {
      this.typeChart?.resize()
      this.levelChart?.resize()
    },
    async fetchData() {
      try {
        this.loading = true
        const res = await request.get('/api/analysis/game/distribution')
        this.chartData = {
          types: res.data.types || [],
          levels: res.data.levels || []
        }
        this.updateCharts()
      } catch (error) {
        console.error('获取数据失败:', error)
        this.$message.error('获取数据失败')
      } finally {
        this.loading = false
      }
    },
    getTypeColor(index) {
      const colors = [
        '#3498DB', '#E74C3C', '#2ECC71', '#9B59B6', '#F1C40F',
        '#1ABC9C', '#E67E22', '#34495E', '#C0392B', '#27AE60',
        '#8E44AD', '#F39C12', '#16A085', '#D35400', '#7F8C8D'
      ]
      return colors[index % colors.length]
    },
    getLevelColor(index) {
      const colors = [
        '#FF6B6B', '#4ECDC4', '#45B7D1', '#96CEB4', '#FFEAA7',
        '#DDA0DD', '#98D8C8', '#F7DC6F', '#BB8FCE', '#85C1E9',
        '#F8C471', '#82E0AA', '#F1948A', '#85C1E9', '#D7BDE2'
      ]
      return colors[index % colors.length]
    },
    updateCharts() {
      this.updateTypeChart()
      this.updateLevelChart()
    },
    updateTypeChart() {
      if (!this.chartData.types || this.chartData.types.length === 0) {
        const emptyOption = {
          backgroundColor: '#ffffff',
          title: {
            text: '暂无数据',
            left: 'center',
            top: 'center',
            textStyle: {
              color: '#999',
              fontSize: 14
            }
          }
        }
        this.typeChart.setOption(emptyOption, true)
        return
      }

      const option = {
        backgroundColor: '#ffffff',
        tooltip: {
          trigger: 'item',
          confine: true,
          enterable: false,
          hideDelay: 100,
          backgroundColor: 'rgba(50, 50, 50, 0.9)',
          borderColor: '#333',
          textStyle: {
            color: '#fff',
            fontSize: 11
          },
          formatter: (params) => {
            if (!params || !params.data) return ''
            const name = params.name || ''
            const value = params.value || 0
            const percent = params.percent || 0
            return `
              <div style="padding: 4px;">
                <div style="font-weight: bold; margin-bottom: 6px;">${name}</div>
                <div style="margin-top: 6px; padding-top: 6px; border-top: 1px solid rgba(255, 255, 255, 0.3);">
                  <div>数量：${value}</div>
                  <div>占比：${percent.toFixed(1)}%</div>
                </div>
              </div>
            `
          }
        },
        legend: {
          orient: 'vertical',
          left: '20px',
          top: 'center',
          itemGap: 8,
          itemWidth: 12,
          itemHeight: 8,
          textStyle: {
            fontSize: 10,
            color: '#666'
          }
        },
        series: [
          {
            name: '赛事类型',
            type: 'pie',
            radius: ['45%', '65%'],
            center: ['60%', '50%'],
            avoidLabelOverlap: true,
            itemStyle: {
              borderRadius: 6,
              borderColor: '#fff',
              borderWidth: 2
            },
            label: {
              show: false,
              position: 'center'
            },
            emphasis: {
              label: {
                show: true,
                fontSize: '14',
                fontWeight: 'bold'
              }
            },
            labelLine: {
              show: false
            },
            data: this.chartData.types.map((item, index) => ({
              value: item.value,
              name: item.name,
              itemStyle: {
                color: item.color || this.getTypeColor(index)
              }
            }))
          }
        ]
      }

      this.typeChart.setOption(option, true)
    },
    updateLevelChart() {
      if (!this.chartData.levels || this.chartData.levels.length === 0) {
        const emptyOption = {
          backgroundColor: '#ffffff',
          title: {
            text: '暂无数据',
            left: 'center',
            top: 'center',
            textStyle: {
              color: '#999',
              fontSize: 14
            }
          }
        }
        this.levelChart.setOption(emptyOption, true)
        return
      }

      const option = {
        backgroundColor: '#ffffff',
        tooltip: {
          trigger: 'item',
          confine: true,
          enterable: false,
          hideDelay: 100,
          backgroundColor: 'rgba(50, 50, 50, 0.9)',
          borderColor: '#333',
          textStyle: {
            color: '#fff',
            fontSize: 11
          },
          formatter: (params) => {
            if (!params || !params.data) return ''
            const name = params.name || ''
            const value = params.value || 0
            const percent = params.percent || 0
            return `
              <div style="padding: 4px;">
                <div style="font-weight: bold; margin-bottom: 6px;">${name}</div>
                <div style="margin-top: 6px; padding-top: 6px; border-top: 1px solid rgba(255, 255, 255, 0.3);">
                  <div>数量：${value}</div>
                  <div>占比：${percent.toFixed(1)}%</div>
                </div>
              </div>
            `
          }
        },
        legend: {
          orient: 'vertical',
          left: '20px',
          top: 'center',
          itemGap: 8,
          itemWidth: 12,
          itemHeight: 8,
          textStyle: {
            fontSize: 10,
            color: '#666'
          }
        },
        series: [
          {
            name: '赛事级别',
            type: 'pie',
            radius: ['45%', '65%'],
            center: ['60%', '50%'],
            avoidLabelOverlap: true,
            itemStyle: {
              borderRadius: 6,
              borderColor: '#fff',
              borderWidth: 2
            },
            label: {
              show: false,
              position: 'center'
            },
            emphasis: {
              label: {
                show: true,
                fontSize: '14',
                fontWeight: 'bold'
              }
            },
            labelLine: {
              show: false
            },
            data: this.chartData.levels.map((item, index) => ({
              value: item.value,
              name: item.name,
              itemStyle: {
                color: item.color || this.getLevelColor(index)
              }
            }))
          }
        ]
      }

      this.levelChart.setOption(option, true)
    },
    // 赛事类型相关方法
    handleExportType() {
      const dpr = window.devicePixelRatio || 1
      const pixelRatio = Math.min(3, dpr * 1.5)
      const dataURL = this.typeChart.getDataURL({ type: 'png', pixelRatio, backgroundColor: '#fff' })
      const blob = this.dataURLToBlob(dataURL)
      this.downloadBlob(blob, 'game_type_distribution.png')
    },
    handleFullscreenType() {
      this.typeDialogVisible = true
    },
    handleTypeDialogOpen() {
      if (this.isInitializing) return
      this.isInitializing = true

      this.$nextTick(() => {
        try {
          const chartDom = this.$refs.typeFullscreenChart
          if (!chartDom) return

          this.typeFullscreenChart = echarts.init(chartDom)
          const option = this.typeChart.getOption()
          
          // 全屏时调整配置
          option.grid = {
            left: '5%',
            right: '5%',
            bottom: '10%',
            top: '10%',
            containLabel: true
          }

          this.typeFullscreenChart.setOption(option)
          
          this.resizeHandler = _.debounce(() => {
            if (this.typeFullscreenChart) {
              this.typeFullscreenChart.resize()
            }
          }, 100)

          window.addEventListener('resize', this.resizeHandler)
        } catch (error) {
          console.error('初始化全屏图表失败:', error)
          this.$message.error('初始化图表失败')
        } finally {
          this.isInitializing = false
        }
      })
    },
    handleTypeDialogClosed() {
      this.isInitializing = false
    },
    closeTypeDialog() {
      this.typeDialogVisible = false
    },
    handleExportTypeFullscreen() {
      if (!this.typeFullscreenChart) return
      
      try {
        const dpr = window.devicePixelRatio || 1
        const pixelRatio = Math.min(3, dpr * 1.5)
        const dataURL = this.typeFullscreenChart.getDataURL({ type: 'png', pixelRatio, backgroundColor: '#fff' })
        const blob = this.dataURLToBlob(dataURL)
        this.downloadBlob(blob, 'game_type_distribution.png')
      } catch (error) {
        console.error('导出图片失败:', error)
        this.$message.error('导出图片失败')
      }
    },
    // 赛事级别相关方法
    handleExportLevel() {
      const dpr = window.devicePixelRatio || 1
      const pixelRatio = Math.min(3, dpr * 1.5)
      const dataURL = this.levelChart.getDataURL({ type: 'png', pixelRatio, backgroundColor: '#fff' })
      const blob = this.dataURLToBlob(dataURL)
      this.downloadBlob(blob, 'game_level_distribution.png')
    },
    handleFullscreenLevel() {
      this.levelDialogVisible = true
    },
    handleLevelDialogOpen() {
      if (this.isInitializing) return
      this.isInitializing = true

      this.$nextTick(() => {
        try {
          const chartDom = this.$refs.levelFullscreenChart
          if (!chartDom) return

          this.levelFullscreenChart = echarts.init(chartDom)
          const option = this.levelChart.getOption()
          
          // 全屏时调整配置
          option.grid = {
            left: '5%',
            right: '5%',
            bottom: '10%',
            top: '10%',
            containLabel: true
          }

          this.levelFullscreenChart.setOption(option)
          
          this.resizeHandler = _.debounce(() => {
            if (this.levelFullscreenChart) {
              this.levelFullscreenChart.resize()
            }
          }, 100)

          window.addEventListener('resize', this.resizeHandler)
        } catch (error) {
          console.error('初始化全屏图表失败:', error)
          this.$message.error('初始化图表失败')
        } finally {
          this.isInitializing = false
        }
      })
    },
    handleLevelDialogClosed() {
      this.isInitializing = false
    },
    closeLevelDialog() {
      this.levelDialogVisible = false
    },
    handleExportLevelFullscreen() {
      if (!this.levelFullscreenChart) return
      
      try {
        const dpr = window.devicePixelRatio || 1
        const pixelRatio = Math.min(3, dpr * 1.5)
        const dataURL = this.levelFullscreenChart.getDataURL({ type: 'png', pixelRatio, backgroundColor: '#fff' })
        const blob = this.dataURLToBlob(dataURL)
        this.downloadBlob(blob, 'game_level_distribution.png')
      } catch (error) {
        console.error('导出图片失败:', error)
        this.$message.error('导出图片失败')
      }
    }
  }
}
</script>

<style scoped>
.game-distribution-mobile {
  width: 100%;
  padding: 0;
  box-sizing: border-box;
  margin-bottom: 16px;
}

.chart-card {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

.card-header {
  display: flex;
  align-items: center;
  padding: 17px 20px;
  height: 16px;
  box-sizing: content-box;
  background-color: #2E365A;
  color: #ffffff;
  border-radius: 8px 8px 0 0;
}

.card-title {
  font-size: 16px;
  font-weight: 500;
  color: white;
}

.chart-container {
  padding: 0;
}

.chart-section {
  margin-bottom: 24px;
}

.chart-section:last-child {
  margin-bottom: 0;
}

.section-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
  padding: 0 12px;
}

.section-actions {
  display: flex;
  gap: 8px;
}

.section-actions .el-button {
  color: #666;
  padding: 4px;
  font-size: 12px;
}

.section-actions .el-button:hover {
  color: #409EFF;
}

.section-title {
  font-size: 14px;
  color: #333;
  margin: 0;
  font-weight: 500;
}

.sub-chart {
  width: 100%;
  height: 250px;
  border-radius: 6px;
  background: #fafafa;
  padding: 0;
}

.chart-dialog :deep(.el-dialog__header) {
  padding: 0;
  margin: 0;
}

.chart-dialog :deep(.el-dialog__headerbtn) {
  display: none;
}

.chart-dialog :deep(.el-dialog__body) {
  padding: 0;
}

.dialog-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 17px 20px;
  height: 16px;
  box-sizing: content-box;
  background-color: #2E365A;
  color: #ffffff;
  border-bottom: none;
}

.dialog-actions {
  display: flex;
  gap: 8px;
}

.dialog-actions .el-button {
  color: #fff;
  padding: 4px;
}

.dialog-actions .el-button:hover {
  color: #BD6C73;
}

.fullscreen-chart {
  width: 100%;
  height: 500px;
  padding: 0;
  box-sizing: border-box;
}

/* 移动端优化 */
@media (max-width: 480px) {
  .game-distribution-mobile {
    padding: 0;
    margin-bottom: 12px;
  }
  
  .chart-container {
    padding: 12px;
  }
  
  .sub-chart {
    height: 200px;
    padding: 0;
  }
  
  .card-header {
    padding: 12px 16px;
  }
  
  .card-title {
    font-size: 14px;
  }
  
  .fullscreen-chart {
    height: 400px;
    padding: 0;
  }
  
  .section-title {
    font-size: 13px;
  }
  
  .section-header {
    padding: 0 8px;
  }
  
  .section-actions .el-button {
    font-size: 11px;
    padding: 2px;
  }
}
</style>
